// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__cYmLJ","tab":"Tabs_tab__bEOBy","tabActive":"Tabs_tabActive__oPdlM"};